const getHistoricMonthName = (daysAgo: number) => {
    const remoteDate = new Date();
    remoteDate.setDate(remoteDate.getDate() - daysAgo);
    return remoteDate.toLocaleString('en-US', {month: 'short'});
}

const calculateTimeScale = () => {
    let lastMonth = '';
    const returnData = [];
    for (let weeks = 51; weeks >= 0; weeks--) {
        const daysAgo = weeks * 7
        const month = getHistoricMonthName(daysAgo)
        if (lastMonth === month) {
            returnData.push('')
        }
        else
            returnData.push(month)
        lastMonth = month
    }
    return returnData.reverse();
}

export default calculateTimeScale;